import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import ItemView from '../../components/ItemView';
import classNames from 'classnames';

class HalfOrderView extends Component {
  toggleAnimationKey = () => {
    return this.props.toggleAnimation ? 1 : 2;
  };

  renderSec = () => {
    return (
      <CSSTransition
        key={this.toggleAnimationKey()}
        classNames='example1'
        timeout={{ enter: 500, exit: 500 }}
        component='div'
      >
        <ItemView
          key={this.toggleAnimationKey()}
          ingredientCategories={this.props.ingredientCategories}
          sizeName={this.props.sizeName}
          orderItem={this.props.orderItem}
          name={
            this.props.orderItem && this.props.orderItem.name
              ? this.props.orderItem.name
              : ''
          }
          imageUrl={
            this.props.orderItem && this.props.orderItem.urlS3
              ? this.props.orderItem.urlS3
              : ''
          }
          description={
            this.props.orderItem && this.props.orderItem.description
              ? this.props.orderItem.description
              : ''
          }
          closeItem={this.props.closeOrder}
          itemInProgress={this.props.itemInProgress}
          openedItemId={this.props.openedItemId}
          addToOrder={this.props.addToOrder}
          rightSideViewVisibilityIndex={this.props.rightSideViewVisibilityIndex}
          history={this.props.history}
          openedFrom={'half'}
          soldOutMenuItems={this.props.soldOutMenuItems}
        />
      </CSSTransition>
    );
  };

  render() {
    return (
      <div
        className={
          this.props.rightSideViewVisibilityIndex === 5
            ? 'orderViews itemV active halfD'
            : 'orderViews halfD'
        }
      >
        <TransitionGroup className='order-items'>
          {this.props.itemInProgress && this.renderSec()}
        </TransitionGroup>
      </div>
    );
  }
}

HalfOrderView.propTypes = {
  rightSideViewVisibilityIndex: PropTypes.any,
  sizeName: PropTypes.any,
};

export default HalfOrderView;
